// Keep aligned with silo/ui/lib_ui-services/src/constants/acceptableTop{,Profile}Blocks.js.
// The shared compiler stays independent of UI services.
exports.acceptableTopBlocks = Object.freeze([
    'page_Page',
    'page_NavigationLink',
    'page_NavigationSelectedContextPage',
    'navHeading_NavHeading',
    'navHeading_TabNavHeading'
]);

exports.acceptableTopProfileBlocks = Object.freeze([
    'menu_Menu',
    'menu_MeatballProfileLayout',
    'profileMenu_MeatballProfileLayout'
]);
